import React from 'react';
import { Col, Skeleton } from 'antd';

const LoadingScreen: React.FC = () => {
  return (
    <Col span={14}>
      <Skeleton active />
    </Col>
  );
};

export default LoadingScreen;
